import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import settings from './modules/settings'
import errorLog from './modules/errorLog'
/* import permission from './modules/permission' */
import tagsView from './modules/tagsView'
import user from './modules/user'
import empresa from './modules/empresa'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    settings,
    errorLog,
    /* permission, */
    tagsView,
    user,
    empresa
  },
  getters
})

export default store
